import React from 'react';
import { Plant } from '../../../../types/api/Plant';
import { useFormikContext } from 'formik';
import {
  ControlLabel,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import cx from 'classnames';
import { PlantChoiceFormValues } from './PlantChoice';
import {
  WithTranslation,
  withTranslation,
} from 'react-i18next';

const PlantDropdown = (props: {
  onChange: (e: React.FormEvent<FormControl>) => void,
  plants: Plant[],
} & WithTranslation) => {
  const {
    values,
    touched,
    errors,
  } = useFormikContext<PlantChoiceFormValues>();
  return (
    <FormGroup className={cx({'has-error': errors.plantId && touched.plantId})}>
      <ControlLabel>{props.t('Plant')}</ControlLabel>
      <FormControl
        componentClass="select"
        id="plant-select"
        name="plantId"
        value={values.plantId || ''}
        onChange={props.onChange}
        bsSize="sm"
      >
        <option/>
        {props.plants.map(plant => (
          <option
            key={plant.id}
            value={plant.id}
            title={`#${plant.id}`}
          >
            {plant.description || plant.shortDescription}
          </option>
        ))}
      </FormControl>
    </FormGroup>
  );
};

export default withTranslation()(PlantDropdown);
